export default {
  grid: {
    column: {
      deposit: 'Đặt cọc',
      company: 'Công ty đại lý du lịch',
      refundMoney: 'Số tiền hoàn',
      refundReason: 'Lí do hoàn',
      refundType: 'Hình thức hoàn',
      applyPerson: 'Người thao tác',
      sumMoneyFree: 'Tổng số tiền miễn phí',
      averagePrice: 'Giá trung bình',
      capacityRoom: 'Công suất phòng',
      revenueBeforeAdjust: 'Doanh thu trước khi điều chỉnh',
      revenueAfterAdjust: 'Doanh thu sau khi điều chỉnh',
      extrabed: 'Extra Bed',
      extraKids: 'Extra Kids',
      laundry: 'Giặt là',
      compensation: 'Đền bù',
      spa: 'Spa',
      restaurant: 'Nhà hàng',
      other: 'Khác',
      code: 'Mã',
      roomStatus: 'Trạng thái buồng phòng',
      diff: 'Sai lệch',
      bookingRoomStatus: 'Trạng thái khách',
      desc: 'Mô tả',
      newRequest: 'Yêu cầu mới',
      received: 'Đã nhận',
      rejected: 'Đã từ chối',
      completed: 'Đã hoàn thành',
      status: 'Trạng thái',
      requestDate: 'Ngày yêu cầu',
      workType: 'Loại việc',
      processingTime: 'Thời gian xử lý',
      room: 'Phòng',
      roomLevel: 'Hạng phòng',
      workDesc: 'Mô tả công việc',
      assignAction: 'Tác vụ đi kèm',
      dateRequestCompleted: 'Ngày yêu cầu hoàn thành',
      priority: 'Ưu tiên',
      requestBy: 'Người yêu cầu',
      receivedDate: 'Ngày nhận',
      receivedPerson: 'Nguời nhận',
      receivedDesc: 'Mô tả khi tiếp nhận',
      finishDate: 'Ngày hoàn thành',
      finishPerson: 'Người hoàn thành',
      finishDesc: 'Mô tả khi hoàn thành',
      rejectedDate: 'Ngày từ chối',
      rejectedPerson: 'Người từ chối',
      rejectedDesc: 'Mô tả khi từ chối',
      type: 'Loại',
      fromDate: 'Từ ngày',
      toDate: 'Đến ngày',
      returnStatus: 'Trả về trạng thái',
      reason: 'Lý do',
      createdPerson: 'Người tạo',
      createdTime: 'Thời gian tạo',
      timeFrame: 'Khung giờ',
      percentage: 'Phần trăm',
      earlyCheckIn: 'Nhận phòng sớm',
      lateCheckIn: 'Trả phòng muộn',
      equivalentRoomNight: 'Đêm phòng tương đương',
      currencyUnit: 'Đơn vị tiền tệ',
      transactionCode: 'Mã giao dịch',
      folioNum: 'Số Folio',
      invoiceNumberSequence: 'Số hóa đơn',
      subTransactionCode: 'Mã giao dịch phụ',
      amountOfMoney: 'Số tiền',
      categoryCode: 'Mã danh mục',
      active: 'Hoạt động',
      packageCode: 'Mã gói',
      packageName: 'Tên gói',
      startSaleDate: 'Ngày bắt đầu bán',
      endSaleDate: 'Ngày kết thúc bán',
      transactionNameCode: 'Mã - tên giao dịch',
      subTransactionNameCode: 'Mã - tên giao dịch phụ',
      frequencyUse: 'Tần suất sử dụng',
      billingRule: 'Quy tắc tính tiền',
      packageGroupCode: 'Mã nhóm gói',
      priceCode: 'Mã giá',
      codeDetail: 'Mã chi tiết',
      effectiveDate: 'Ngày có hiệu lực',
      expiryDate: 'Ngày hết hiệu lực',
      applicableDaysInWeek: 'Ngày áp dụng trong tuần',
      applicablePeopleAmount: 'Số lượng người áp dụng',
      applicableNightAmount: 'Số đêm áp dụng',
      price: 'Giá',
      packagePackageGroupCode: 'Mã gói/Mã nhóm gói',
      staff: 'Nhân viên',
      object: 'Đối tượng',
      task: 'Tác vụ',
      timeOperation: 'Thời gian thao tác',
      explanation: 'Diễn giải',
      order: 'Thứ tự',
      priceCategory: 'Danh mục giá',
      orderDisplay: 'Thứ tự hiển thị',
      currency: 'Tiền tệ',
      marketSegmentCode: 'Mã phân khúc thị trường',
      groupCode: 'Mã nhóm',
      sourceCode: 'Mã nguồn',
      singleGuest: 'Khách đơn',
      mainGuest: 'Khách chính',
      doubleGuest: 'Khách đôi',
      forEachExtraGuest: 'Với mỗi khách thêm',
      transaction: 'Giao dịch',
      subTransaction: 'Giao dịch phụ',
      periodCode: 'Mã giai đoạn',
      packageNameOrPackageGroupName: 'Tên gói/Tên nhóm gói',
      packageCodeOrPackageGroupCode: 'Mã gói/Mã nhóm gói',
      groupName: 'Tên nhóm',
      defaultTransactionPage: 'Trang giao dịch mặc định',
      includeTaxFee: 'Bao gồm thuế, phí',
      breakfastCode: 'Mã ăn sáng',
      adultPrice: 'Giá người lớn',
      childPrice: 'Giá trẻ em',
      notIncludingInRoomRate: 'Không bao gồm trong tiền phòng',
      specialServiceCode: 'Mã dịch vụ đặc biệt',
      openPrice: 'Giá mở',
      feeAmount: 'Số tiền phí',
      currencyCode: 'Mã tiền tệ',
      includingInRoomRate: 'Bao gồm trong tiền phòng',
      recordPercentage: 'Phần trăm ghi nhận',
      dayInWeek: 'Ngày trong tuần',
      roomPairing: 'Ghép phòng',
      billDetail: 'Chi tiết hóa đơn',
      detach: 'Tách',
      reservation: 'Đặt phòng',
      confirm: 'Xác nhận',
      customerName: 'Tên khách',
      comeDate: 'Ngày đến',
      departDate: 'Ngày đi',
      free: 'Miễn phí',
      internal: 'Nội bộ',
      serviceDate: 'Ngày dịch vụ',
      tradingCode: 'Mã GD',
      reference: 'Tham chiếu',
      moneyTotal: 'Tổng tiền thanh toán',
      foc: 'FOC',
      note: 'Ghi chú',
      taxLevel: 'Mức thuế (%)',
      chargeFeeLevel: 'Mức phí (%)',
      accountCode: 'Mã tài khoản',
      accountNum: 'Số tài khoản',
      bankAccountName: 'Tài khoản ngân hàng',
      pmsSite: 'Dùng cho PMS',
      ticketSite: 'Dùng cho bán vé',
      name: 'Tên',
      basis: 'Cơ sở',
      devideBasis: 'Chia cho cơ sở',
      decimalDigit: 'Số chữ số thập phân',
      exchangeRate: 'Tỷ giá',
      viName: 'Tên tiếng Việt',
      enName: 'Tên tiếng Anh',
      target: 'Mục tiêu',
      serviceType: 'Loại dịch vụ',
      total: 'Tổng',
      availableRoom: 'Phòng trống',
      roomLevelName: 'Tên hạng phòng',
      oooRoom: 'Phòng không sử dụng',
      oosRoom: 'Phòng không phục vụ',
      dirtyRoom: 'Phòng bẩn',
      cleanRoom: 'Phòng sạch',
      checkedRoom: 'Phòng đã kiểm tra',
      currentStatus: 'Trạng thái hiện tại',
      attribute: 'Thuộc tính',
      connectingRoom: 'Phòng thông nhau',
      commonPrice: 'Giá chung',
      unitPrice: 'Giá đơn vị',
      briefInfo: 'TT',
      roomNum: 'Số phòng',
      balance: 'Số dư',
      transactionDate: 'Ngày GD',
      initRoom: 'Mã đặt phòng gốc',
      transactionPage: 'Trang giao dịch',
      amountExcludeTax: 'Số tiền trước thuế, phí',
      feePercent: '% Phí',
      taxPercent: '% Thuế',
      taxAmount: 'Tiền thuế',
      amountIncludeTax: 'Số tiền sau thuế, phí',
      bookingCode: 'Mã đặt phòng',
      recodeNumber: 'Số lượng đặt phòng',
      nameGuest: 'Tên khách',
      source: 'Nguồn',
      transPage: 'Trang GD',
      numRoomofLevel: 'Số lượng phòng theo hạng phòng',
      dateOrder: 'Ngày đặt',
      numGuest: 'Số lượng khách',
      numNight: 'Số đêm',
      roomPrice: 'Giá phòng',
      realRevenue: 'Doanh thu thực',
      employee: 'Nhân viên',
      date: 'Ngày',
      allRoom: 'Tổng số phòng',
      occupiedRoom: 'Phòng bị chiếm',
      OOORoom: 'Số lượng phòng sửa chữa OOO',
      canBuyRoom: 'Phòng có thể bán',
      freeRoom: 'Phòng miễn phí',
      occupiedRevenue: 'Doanh thu của những phòng bị chiếm',
      fullRevenue: 'Doanh thu khi full',
      percentRevenue: 'Tỉ lệ doanh thu thực',
      capacity: 'Công suất',
      subBookingCode: 'Đặt phòng',
      customerStatus: 'Trạng thái khách',
      vip: 'VIP',
      roomLevelReservation: 'Hạng phòng đặt',
      splitAmount: 'Số tiền tách',
      restAmount: 'Số tiền còn lại',
      fromPageTransaction: 'Trang giao dịch',
      toPageTransaction: 'Đến trang giao dịch',
      fromRoom: 'Phòng nguồn',
      toRoom: 'Tới phòng',
      toFolio: 'Đến mã đặt phòng',
      customerInfo: 'Thông tin khách hàng',
      amount: 'Tổng tiền',
      splitPercent: '% Tách',
      master: 'Đoàn master',
      confirmCode: 'Mã xác nhận',
      firstName: 'Tên',
      email: 'Email',
      phone: 'SĐT',
      addressLine1: 'Địa chỉ 1',
      addressLine2: 'Địa chỉ 2',
      lastName: 'Họ',
      arrivalDate: 'Ngày đến',
      departureDate: 'Ngày đi',
      customerLevel: 'Hạng khách',
      roomNumber: 'Số phòng',
      accountName: 'Tên tài khoản',
      surplus: 'Số dư',
      taxCode: 'Mã số thuế',
      address: 'Địa chỉ',
      phoneNum: 'Số điện thoại',
      debtPeriod: 'Số ngày được nợ',
      debtMax: 'Số tiền nợ tối đa',
      folioInvoice: 'Folio/Hóa đơn',
      debtSurplus: 'Số dư công nợ',
      amountOfDebtInvoice: 'Số hóa đơn công nợ',
      surplusInvoiceDebt: 'Số dư hóa đơn công nợ',
      debtAccountName: 'Tên tài khoản công nợ',
      debtAccount: 'Số tài khoản công nợ',
      initMoney: 'Số tiền gốc',
      largeGroupCode: 'Mã đoàn',
      arrivalRoom: 'Phòng đến',
      departureRoom: 'Phòng đi',
      adult: 'Người lớn',
      child: 'Trẻ em',
      infant: 'Trẻ em <5T',
      phoneNumber: 'Số điện thoại',
      revueneDiscount: 'Doanh thu sau khi giảm giá',
      deposited: 'Đã cọc',
      collect: 'Cần thu',
      roomName: 'Tên phòng',
      tablePrice: 'Bảng giá',
      discount: 'Giảm giá',
      discountMoney: 'Số tiền giảm',
      discountPrice: 'Giá sau khi giảm',
      staffBooking: 'Nhân viên đặt phòng',
      cancelDate: 'Ngày hủy',
      cancelAccount: 'Tài khoản hủy',
      cancelReason: 'Lí do hủy',
      pay: 'Trả',
      service: 'Dịch vụ',
      revenue: 'Doanh thu',
      user: 'Người dùng',
      createDatetime: 'Thời gian tạo',
      cancelDatetime: 'Thời gian hủy',
      paymethod: 'Hình thức thanh toán',
      productCode: 'Mã sản phẩm',
      productName: 'Tên sản phẩm',
      priceUnit: 'Đơn giá',
      quantity: 'Số lượng',
      // discount: 'Giảm giá'
      intoMoney: 'Thành tiền',
      arrivalHour: 'Giờ đến',
      specialService: 'Dịch vụ đặc biệt',
      equipmentCode: 'Mã thiết bị',
      packageGroupName: 'Tên nhóm gói',
      equipmentName: 'Tên thiết bị',
      quantityEachRoom: 'Số lượng mỗi phòng',
      quantityTotal: 'Số lượng tổng',
      good: 'Tốt',
      needRepair: 'Cần sửa chữa',
      needReplace: 'Cần thay thế',
      position: 'Chức vụ',
      phone1: 'Số điện thoại 1',
      phone2: 'Số điện thoại 2',
      group: 'Đoàn',
      companyName: 'Tên công ty',
      transferDebt: 'Chuyển công nợ',
      taxNumber: 'Mã số thuế',
      debtDate: 'Số ngày được nợ',
      debtMaxAmount: 'Số tiền nợ tối đa',
      cardId: 'ID thẻ',
      employeeName: 'Tên nhân viên',
      detailRoomNum: 'Số phòng chi tiết',
      usedTime: 'Thời gian sử dụng',
      cardCreatedBy: 'Người tạo thẻ',
      cardCreatedDate: 'Ngày tạo thẻ',
      expiredDate: 'Ngày hết hạn',
      recode: 'Recode',
      mainGuestNameOfRoom: 'Tên khách chính của phòng',
      checkinTime: 'Thời gian Checkin',
      checkoutTimeExpected: 'Thời gian dự kiến Checkout',
      numOfGuest: 'Số lượng khách',
      numericalOrder: 'Số thứ tự',
      checkinDate: 'Ngày Checkin',
      checkoutDate: 'Ngày Checkout',
      receptionist: 'Lễ tân',
      roomNo: 'Số phòng',
      guestName: 'Tên khách',
      serviceDetail: 'Chi tiết dịch vụ',
      roomRate: 'Tiền phòng',
      miniBar: 'Mini bar',
      payment: 'Thanh toán',
      card: 'Thẻ',
      cash: 'Tiền mặt',
      refund: 'Hoàn tiền',
      bankingTransfer: 'Chuyển khoản',
      cashier: 'Thu ngân',
      paymentMethod: 'Hình thức thanh toán',
      receivedAccount: 'Tài khoản nhận',
      bookingGroupName: 'Tên đoàn',
      hotel: 'Khách sạn',
      roomPriceAfterDiscount: 'Giá phòng (Sau chiết khấu)',
      groupNumOfRoom: 'Số lượng phòng của cả đoàn',
      revenueOfOtherSerivces: 'Doanh thu các dịch vụ khác',
      totalAmount: 'Thành tiền',
      paymentStatus: 'Trạng thái thanh toán',
      roomCode: 'Mã phòng',
      previousStatus: 'Trạng thái cũ',
      newStatus: 'Trạng thái mới',
      difference: 'Sự khác nhau',
      updatedTime: 'Thời gian cập nhật',
      updatedByPerson: 'Người cập nhật',
      measurementUnit: 'Đơn vị tính',
      priceOfUnit: 'Giá đơn vị',
      roomState: 'Trạng thái phòng',
      arriveTime: 'Giờ đến',
      leaveTime: 'Giờ đi',
      modifyState: 'Thay đổi trạng thái',
      foundDate: 'Ngày tìm thấy',
      positionOrRoom: 'Ví trí/Phòng',
      bookingRoom: 'Đặt phòng',
      thingsName: 'Tên đồ vật',
      returnDate: 'Ngày trả lại',
      foundBy: 'Tìm thấy bởi',
      returnedByPerson: 'Người trả lại',
      confirmedByPerson: 'Người xác nhận',
      detail: 'Chi tiết',
      currentYear: 'Năm nay',
      lastYear: 'Năm trước',
      monthAccumulated: 'Lũy kế tháng',
      yearAccumulated: 'Lũy kế năm',
      dayofWeek: 'Thứ',
      numRoomArrive: 'Số lượng phòng đến',
      numRoomDepart: 'Số lượng phòng đi',
      adultAndChild: 'Người lớn và trẻ em',
      averagePriceRoom: 'Giá phòng trung bình',
      roomRevenue: 'Doanh thu phòng',
      allRevenue: 'Tổng doanh thu',
      sourceGroup: 'Nhóm nguồn',
      invoiceNumber: 'Số hóa đơn',
      formToDate: 'Ngày đến - Ngày đi',
      createInvoiceDate: 'Ngày tạo hóa đơn',
      amountOfMoneyInvoice: 'Số tiền trên hóa đơn',
      debt: 'Công nợ',
      companyOrAgency: 'Công ty, Đại lý',
      CIDate: 'Ngày CI',
      CODate: 'Ngày CO',
      salesEmployees: 'Nhân viên Sales',
      percent: 'Tỉ lệ',
      numRoom: 'Số lượng phòng',
      operationDateTime: 'Ngày giờ thao tác',
      operation: 'Thao tác',
      smartKeyCode: 'Mã khóa từ',
      numOfNight: 'Số đêm',
      guestPhoneNum: 'Số điện thoại khách',
      revenueAfterDiscount: 'Doanh thu sau khi discount',
      needToCollect: 'Cần thu',
      departmentCode: 'Mã bộ phận',
      departmentName: 'Tên bộ phận',
      recordEmployee: 'Ghi nhận doanh thu cho nhân viên',
      expectedRevenue: 'Doanh thu dự kiến',
      monday: 'Thứ hai',
      tuesday: 'Thứ ba',
      wednesday: 'Thứ tư',
      thursday: 'Thứ năm',
      friday: 'Thứ sáu',
      saturday: 'Thứ bảy',
      sunday: 'Chủ nhật',
      inventory: 'Inventory',
      numOfUsed: 'Đã sử dụng',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      segmentOrAgency: 'Segment/Đại lý',
      department: 'Bộ phận',
      segment: 'Segment',
      agencyCode: 'Mã đại lý',
      agencyName: 'Tên đại lý',
      arriveDate: 'Ngày đến',
      employeeID: 'ID Nhân viên',
      fullname: 'Họ và tên',
      username: 'Tên đăng nhập',
      function: 'Chức năng',
      functionCode: 'Mã chức năng',
      order1: 'STT',
      foundedDate: 'Ngày tìm thấy',
      foundedPosition: 'Vị trí/Phòng',
      objectName: 'Tên đồ vật',
      calculationUnit: 'Đơn vị tính',
      expectAdult: 'SL người lớn dự kiến',
      expectChild: 'SL trẻ em dự kiến',
      realAdult: 'SL người lớn thực tế',
      realChild: 'SL trẻ em thực tế',
      quick_purchase: 'Là sản phẩm mua hàng nhanh',
      is_open: 'Là sản phẩm mở',
      stop_using: 'Ngừng sử dụng',
      product_cal_unit_unit: 'Đơn vị chính',
      convert_unit: 'Đơn vị chuyển dổi',
      convert_rate: 'Tỷ lệ quy đổi về đơn vị chính',
      calculation: 'Phép tính chuyển đổi',
      product_port_folio_code: 'Mã danh mục',
      roomPriceinWeek: 'Giá phòng trong tuần',
      roomPriceWeekend: 'Giá phòng cuối tuần',
      agentName: 'Công ty, đại lý du lịch',
      finishProductCode: 'Mã sản phẩm',
      materialCode: 'Tên nguyên vật liệu',
      materialCalUnit: 'Đơn vị của nguyên vật liệu',
      extraBed: 'Extra bed',
      extraKid: 'Extra kids',
      extraPax: 'Extra pax',
      invoiceNum: 'Mã hóa đơn',
      roomCharge: 'Tiền phòng',
      invoiceCode: 'Hoá đơn',

      pmsCode: 'PMS Recode',
      cmCode: 'CM Recode',
      hotelLinkStatus: 'Status',
      hotelLinkChannel: 'Channel',
      hotelLinkBookingDate: 'Booking Date',
      hotelLinkCheckin: 'Checkin',
      hotelLinkCheckout: 'Checkout',
      hotelLinkName: 'Tên khách',
      hotelLinkPhone: 'Số điện thoại',
      hotelLinkRoomNum: 'SL Phòng',
      hotelLinkGuestNum: 'SL Khách',
      hotelLinkTotalAmount: 'Total Amount',
      hotelLinkPaymentNote: 'Payment Note',
      hotelLinkBookingNote: 'Booking Note'
    },
    row: {
      occupiedNotInternal: 'Bị chiếm (trừ nội bộ)',
      fit: 'Khách lẻ(trừ miễn phí, nội bộ)',
      booking: 'Đoàn(trừ miễn phí, nội bộ)',
      internal: 'Nội bộ',
      totalOccupied: 'Tổng bị chiếm',
      free: 'Miễn phí',
      occupied: 'Bị chiếm',
      roomChecked: 'Phòng kiểm tra',
      cleaRoom: 'Phòng sạch',
      roomCleanedBriefly: 'Dọn sơ qua',
      dirtyRoom: 'Phòng bẩn',
      oos: 'Phòng không phục vụ',
      ooo: 'Phòng ngưng sử dụng',
      oooOos: 'Phòng ngưng sử dụng',
      totalPhysicRoom: 'Tổng số phòng vật lý',
      saleAvailable: 'Tổng số phòng có thể bán',
      sleep: 'Sleep',
      skip: 'Skip',
      expectedDepart: 'Dự kiến đi',
      realityDepart: 'Thực tế đi',
      expectedArrive: 'Dự kiến đến',
      realityArrive: 'Thực tế đến',
      roomAssigned: 'Phòng đã gán trước',
      stay: 'Đang ở',
      extendStay: 'Gia hạn chặng ở',
      early: 'Đi sớm',
      inDay: 'Phòng ở trong ngày',
      createInDay: 'Phòng tạo trong ngày',
      walkIn: 'Walk-ins',
      changeRoom: 'Chuyển phòng'
    }
  }
}
